import {
  exportLedgerInvoices,
  exportPaidInvoices,
  exportCreditInvoices,
  exportDeductedInvoices,
  exportHistoricalLedger,
  exportReceivables,
  exportTransactions,
  exportCustomers,
  exportDepositions,
  exportPayments,
} from './web-api';
import { pieChartStatusInfo } from '../../pages/ledger/ledger-utils';
import months from '../data/months';


// eslint-disable-next-line no-extend-native, func-names
String.prototype.lpad = function (padString, length) {
  let str = this;
  while (str.length < length) { str = padString + str; }
  return str;
};

export const exportPage = {
  LEDGER: 'ledger',
  PAIDINVOICES: 'paid-invoices',
  CREDIT: 'credit',
  DEDUCTED: 'deducted',
  HISTORICALLEDGER: 'historical-ledger',
  RECEIVABLES: 'receivables',
  TRANSACTIONS: 'transactions',
  DEPOSITIONS: 'depositions',
  CUSTOMERS: 'customers',
  PAYMENTS: 'payments',
};

export const saveFormat = {
  XLSX: 1,
  CSV: 2,
};

export const stateFilter = {
  ALL: 1,
  UNPAYED: 2,
  PAYED: 3,
  OVERDUE: 4,
  SOLD: 5,
  MONITORED: 6,
  REMAINING: 7,
  HISTORICAL: 8,
  CREDIT: 9,
  SOLD_WITHOUT_CREDIT: 10,
  MONITORED_WITHOUT_CREDIT: 11,
};

const getMonthNumber = (month) => {
  const monthNumber = months.map((item) => item.value).indexOf(month) + 1;
  return monthNumber.toString().lpad('0', 2);
};

export const toISODate = (date) => (date ? new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000) : undefined);

const getStartDate = (filterArgs) => {
  if (filterArgs.filter.year) {
    return toISODate(new Date(`${filterArgs.filter.year}-${getMonthNumber(filterArgs.filter.month)}-01`));
  }
  return toISODate(filterArgs.filter.fromDate);
};

const getEndDate = (filterArgs) => {
  if (filterArgs.filter.year) {
    const date = new Date(`${filterArgs.filter.year}-${getMonthNumber(filterArgs.filter.month)}-01`);
    return toISODate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
  }
  return toISODate(filterArgs.filter.toDate);
};

const getStateFilter = (filter) => {
  if (filter) {
    if (filter.filter.state) {
      return stateFilter[filter.filter.state];
    }
    if (filter.filter.invoiceState) return stateFilter[filter.filter.invoiceState];
  }

  return undefined;
};

const getFilterStatus = (filter) => {
  if (filter) {
    if (filter.filter.pieChartLabelWithIndex) {
      const isLabelParam = filter.filter.pieChartLabelWithIndex.indexOf('(') !== -1;
      const label = isLabelParam ? filter.filter.pieChartLabelWithIndex.split('(')[0].trim() : filter.filter.pieChartLabelWithIndex.split('::')[0];
      const item = pieChartStatusInfo.find((i) => i.status === label);
      if (item) return item.sortOrder;
    }
  }

  return undefined;
};

export const exportFile = (
  page,
  filter,
  // eslint-disable-next-line no-shadow
  saveFormat,
  exportHandler,
  openModal,
  t,
  selectedLanguage,
) => {
  let promise;
  let viewName = [];

  // eslint-disable-next-line default-case
  switch (page) {
    case exportPage.LEDGER:
      promise = exportLedgerInvoices;
      viewName = [t.invoices, t.account];
      break;
    case exportPage.PAIDINVOICES:
      promise = exportPaidInvoices;
      viewName = [t.invoices, t.fullyPaidInvoices];
      break;
    case exportPage.CREDIT:
      promise = exportCreditInvoices;
      viewName = [t.invoices, t.creditInvoices];
      break;
    case exportPage.DEDUCTED:
      promise = exportDeductedInvoices;
      viewName = [t.invoices, t.deductedInvoices];
      break;
    case exportPage.HISTORICALLEDGER:
      promise = exportHistoricalLedger;
      viewName = [t.invoices, t.historicalLedgerTitle];
      break;
    case exportPage.RECEIVABLES:
      promise = exportReceivables;
      viewName = [t.myDebt];
      break;
    case exportPage.TRANSACTIONS:
      promise = exportTransactions;
      viewName = [t.recentPayments];
      break;
    case exportPage.CUSTOMERS:
      promise = exportCustomers;
      viewName = [t.myCustomers];
      break;
    case exportPage.DEPOSITIONS:
      promise = exportDepositions;
      viewName = [t.deposits];
      break;
    case exportPage.PAYMENTS:
      promise = exportPayments;
      viewName = [t.payments];
      break;
  }

  const exportQueryParams = {
    StartDate: filter ? getStartDate(filter) : null,
    EndDate: filter ? getEndDate(filter) : null,
    SaveFormat: saveFormat,
    CacheKey: exportHandler.cacheKey.get(),
    StateFilter: getStateFilter(filter),
    // eslint-disable-next-line no-nested-ternary
    SearchValue: filter ? (filter.filter.debtor ? filter.filter.debtor : '') : '',
    viewName,
    FilterStatus: getFilterStatus(filter),
    Lang: selectedLanguage,
  };

  exportHandler.setLoading(true);

  promise(exportQueryParams)
    .then((response) => {
      if (response.content) {
        const file = new Blob([response.content], {
          type: response.contentType,
        });

        const fileUrl = URL.createObjectURL(file);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = fileUrl;
        a.download = response.fileName;
        a.click();
        a.remove();
        exportHandler.cacheKey.set(null);
      } else if (!response.success) {
        exportHandler.dispatchStatusMessage({
          type: 'FAILED',
          message: t[response.message],
        });
      } else {
        if (openModal) openModal();
        exportHandler.cacheKey.set(response.data.cacheKey);
      }
    })
    .finally(() => exportHandler.setLoading(false));
};
